import { Canvas } from '@react-three/fiber'
import * as THREE from 'three'
import { Stats, OrbitControls } from '@react-three/drei'
import Boid from './Boid'


function getRandomArr3(lb, ub)
{
    const range = ub-lb+1;
    var x = Math.floor(Math.random() * range) + lb;
    var y = Math.floor(Math.random() * range) + lb;
    var z = Math.floor(Math.random() * range) + lb;
    return [x, y, z];
}

export default function App() {
    const boids = [];
    var boidCount = 1000; // upto 3000 works, make a gui slider for this

    for(let i = 0; i < boidCount; i++) {
        
        boids.push(<Boid position={getRandomArr3(-5, 5)} />);
    }

    return (
        <Canvas camera={{ position: [1, 2, 3] }}>
            {boids}
            {/* TODO 
                - Figure out how to check if objects are intersecting
                - Add the boids to a Group or Particle System 
            */}

            <gridHelper args={[20, 20]} />
            <OrbitControls />
            <axesHelper />
        </Canvas>
    )
}